<div class="raci-checklists-wrapper">
  <div *ngFor="let checklistItem of taskChecklist">
    <div class="raci-checklist-block">
      <h3 class="raci-checklist-title">
        {{checklistItem?.checklistOrderNumber}} | {{checklistItem?.checklistName}}
      </h3>
      <input class="raci-checbox" type="checkbox" [(ngModel)]="checklistItem.checklistItemStatus" (change)="onUpdateChecklistItemStatus($event, checklistItem)" />
    </div>
    <hr class="raci-checklist-line" />
  </div>
</div>
